// extracted by mini-css-extract-plugin
module.exports = {"invalid_field":"Checkbox_invalid_field__6WFgl","checkbox":"Checkbox_checkbox__xVSlm","checked":"Checkbox_checked__wXSpp"};